export function getPostInitialValues() {
    return {
        promoCodeInput: '',
    };
}

const VALIDATION_SCHEMA = () => {
}
export { VALIDATION_SCHEMA };
